import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyGaiaAi = lazyWithRetry(() => import("./GaiaAi"));

const GaiaAi = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyGaiaAi {...props} />;

export default GaiaAi;
